var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"chart-container",style:(`height:${_vm.height}; width:${_vm.width};`)},[_c('canvas',{ref:"chart",attrs:{"dir":"ltr"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }